<div class="wrapper__headerComponent container my-5">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img
        [src]="entidad?.Logo_Miniatura || '../../../../assets/img/H-SALUD.png'"
        alt="logo"
        class="img-ico-form"
      />
      <h2 class="mb-0 ms-2">
        {{ 'detalle-SIC.titulo' | translate }} {{ entidad?.Entidad ?? entidad?.Acronimo}}
      </h2>
    </div>
  </div>
</div>
<div id="encabezado">
  <app-encabezado-expediente></app-encabezado-expediente>
</div>
<div class="wrapper__contentComponent--expediente container my-5">
  <div class="row">
    <div class="col-12 d-flex justify-content-end gap-3 mb-5 flex-wrap">
      <button
        id="documentos"
        *ngIf="isCreator || role !== 'Ciudadano'"
        class="btn-govco outline-btn-govco hvr-shrink"
        (click)="openModal()"
        aria-label="Documentos">
        <span class="govco-svg govco-archive me-2"></span>
        {{ 'detalle-supersociedades.documentos' | translate }}
      </button>
      <button
        id="historicoBtn"
        class="btn-govco outline-btn-govco hvr-shrink"
        (click)="navigateAvanceProcesalSolicitudes()"
        aria-label="Solicitudes">
        <span class="govco-svg govco-search-plus me-2"></span>
        {{ 'detalle-supersociedades.solicitudes' | translate }}
      </button>
      <button
        id="crearSolicitud"
        *ngIf="isCreator || role !== 'Ciudadano'"
        class="btn-govco fill-btn-govco hvr-shrink"
        (click)="crearAvanceProcesal()"
        aria-label="Crear solicitud">
        <span class="govco-svg govco-plus-circle"></span>
        {{ 'detalle-supersociedades.crear' | translate }}
      </button>
    </div>
  </div>
</div>
<div class="wrapper__contentComponent--expediente container my-5">
  <div class="contenedor-tabla w-100">
    <app-table
      id="historico"
      [datos]="actuacionesSupersalud"
      [paginaActual]="paginaActual"
      [columnas]="columns"
      [paginacion]="true"
      [tamano]="tamanoPagina"
      [totalPaginas]="totalPaginas"
      [tamanos]="[1, 5, 10, 20]"
      [localFiltering]="true"></app-table>
  </div>
</div>
